<template>
  <div class="coming-soon">
      <p>{{$locale("global.comingSoon")}}...</p>
  </div>
</template>

<script>

export default {
  name: "coming-soon",
};
</script>

<style lang="less" scoped>
    .coming-soon {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 500px;

        p{
            font-size: 2rem;
            color: @secondly-grey;
        }
    }
</style>
